import { useEffect } from 'react';
import { useUnit } from 'effector-react';

import Radio from '../../forms/Radio/Radio';
import { Frequency } from '../../../model/enums';
import useMediaSize from '../../../hooks/useMediaSize';
import OneTimeCard from './FrequencyRadioCards/OneTimeCard';
import SubscribeCard from './FrequencyRadioCards/SubscribeCard';
import { $cartState, handleSelectFrequency } from '../../../store/models/cart';

import styles from './styles.module.scss';

type Props = {
  mainFreq: any;
  setMainFreq: any;
};

const FrequencyRadio = ({ mainFreq, setMainFreq }: Props) => {
  const { selectedProductFrequency } = useUnit($cartState);

  const mainFreqData = [
    {
      value: 'subscribe',
      cardContent: <SubscribeCard handleSelect={handleFrequencyOptionChange} />,
    },
    {
      value: 'oneTime',
      cardContent: <OneTimeCard />,
    },
  ];
  const { isSmallDesktop, isTablet, isMobile } = useMediaSize();

  let gridStr = '1fr';

  if (isSmallDesktop || isTablet || isMobile) {
    gridStr = '1fr';
  } else {
    gridStr = '1fr 1fr';
  }

  useEffect(() => {
    if (!selectedProductFrequency) {
      setMainFreq('subscribe');
      handleSelectFrequency(Frequency.EveryTwoWeeks);
    }
  }, [setMainFreq, handleSelectFrequency]);

  function handleFrequencyOptionChange(event: any) {
    handleSelectFrequency(event.target.value);
    setMainFreq('subscribe');
  }

  function handleChangeMainFreq(event: any) {
    setMainFreq(event.target.value);
    handleSelectFrequency(
      event.target.value === 'oneTime'
        ? Frequency.Once
        : Frequency.EveryTwoWeeks,
    );
  }

  return (
    <div className={styles.frequencyRadio}>
      <Radio
        data={mainFreqData}
        handleSelect={handleChangeMainFreq}
        selectedOption={mainFreq}
        extraStyle={{
          gridTemplateColumns: gridStr,
        }}
      />
    </div>
  );
};

export default FrequencyRadio;
